import { useEffect } from "react";

function ConfigurationFood() {

  // useEffects
  useEffect(() => {
  }, []);

  return (
    <>
      
    </>
  );
}

export default ConfigurationFood;